import { CelebrationsMainPageTemplate } from "./template";
import { useCelebrationsMainPage } from "./logic";

export const CelebrationsMainPage = () : JSX.Element => {
    const props = useCelebrationsMainPage();

    return (
        <CelebrationsMainPageTemplate {...props}/>
    )
}